<template>
    <div class="search">
        <div class="twrap flex_layout flex_y_center flex_x_spacebetween">
            <div class="dot"></div>
            <div class="title">图形匹配</div>
            <div class="dot"></div>
        </div>
        <div class="cwrap">
            <compCheckbox
                :options="filter.graphGenderList"
                label="用户性别"
                v-model="selectedOptions.gender"
            >
            </compCheckbox>
            <compCheckbox
                :options="filter.graphAgeList"
                label="用户年龄"
                v-model="selectedOptions.age"
            >
            </compCheckbox>
            <div v-show="isViewMore">
                <compCheckbox
                    :options="filter.graphColorList"
                    label="图形色系"
                    v-model="selectedOptions.graph_color_list"
                >
                </compCheckbox>
                <compCheckbox
                    :options="filter.graphStyleList"
                    label="图形风格"
                    v-model="selectedOptions.graph_style_list"
                >
                </compCheckbox>
                <compCheckbox
                    :options="filter.graphTagList"
                    label="图形标签"
                    v-model="selectedOptions.graph_tag_list"
                >
                </compCheckbox>
                <compCheckbox
                    :options="filter.graphFigureList"
                    label="图形形象"
                    v-model="selectedOptions.graph_figure_list"
                >
                </compCheckbox>
                <compCheckbox
                    :options="filter.graphClassList"
                    label="图形类别"
                    v-model="selectedOptions.graph_class_list"
                >
                </compCheckbox>
                <compCheckbox
                    :options="filter.graphGroupList"
                    label="图形组合"
                    v-model="selectedOptions.graph_group_list"
                >
                </compCheckbox>
            </div>
            <div class="more-btn">
                <div v-show="!isViewMore" class="view-more-btn" @click="viewMore">查看更多</div>
                <div v-show="isViewMore" class="pack-more-btn" @click="viewMore">收起</div>
            </div>
            <div class="btn" @click="clickSearch()"><img src="../img/btn_search@2x.png" alt=""/></div>
        </div>
    </div>
</template>

<script>
import { toast } from '@kkmh/utils';
import compCheckbox from './compCheckbox';
import Bus from '../modules/bus';

export default {
    name: 'search',
    components: {
        compCheckbox
    },
    data () {
        return {
            filter: {
                graphGenderList: [
                    {value: 0, label: '不限'},
                    {value: 1, label: '男', iconSrc: require('../img/boy.png')},
                    {value: 2, label: '女', iconSrc: require('../img/girl.png')},
                ],
                graphAgeList: [
                    {value: 0, label: '不限'},
                    {value: 1, label: '11岁以下'},
                    {value: 2, label: '12-17岁'},
                    {value: 3, label: '18-23岁'},
                    {value: 4, label: '24-30岁'},
                    {value: 5, label: '31岁以上'},
                ],
                graphColorList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: '蓝色系' },
                    { value: 2, label: '粉色系' },
                    { value: 3, label: '黄色系' },
                    { value: 4, label: '紫色系' },
                    { value: 5, label: '红色系' },
                    { value: 6, label: '其他' },
                ],
                graphStyleList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: '可爱' },
                    { value: 2, label: '潮酷' },
                    { value: 3, label: '国风' },
                    { value: 4, label: '唯美' },
                    { value: 5, label: '其他' },
                ],
                graphTagList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: '青春' },
                    { value: 2, label: '校园' },
                    { value: 3, label: '都市' },
                    { value: 4, label: '热血' },
                    { value: 5, label: '插画' },
                    { value: 6, label: '悬疑' },
                    { value: 7, label: '萌宠' },
                    { value: 8, label: '奇幻' },
                    { value: 9, label: '古风' },
                ],
                graphFigureList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: 'Q版' },
                    { value: 2, label: '正常版' },
                    { value: 3, label: '其他' },
                ],
                graphClassList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: '人物' },
                    { value: 2, label: '动物' },
                    { value: 3, label: '其他' },
                ],
                graphGroupList: [
                    { value: 0, label: '不限' },
                    { value: 1, label: '单人' },
                    { value: 2, label: '双人' },
                    { value: 3, label: '群像' },
                ],
            },
            selectedOptions: {},
            isViewMore: false,
            ipName: ''
        };
    },
    created () {
        this.initSelectedOptions();
    },
    mounted () {
        Bus.$on('searchByIpName', (ipName) => {
            this.initSelectedOptions();
            this.clickSearch({ ipName, isByNameSearch: true });
        });
    },
    beforeDestroy () {
        Bus.$off('searchByIpName');
    },
    methods: {
        initSelectedOptions () {
            this.selectedOptions = {
                gender: [],
                age: [],
                graph_color_list: [],
                graph_style_list: [],
                graph_tag_list: [],
                graph_figure_list: [],
                graph_class_list: [],
                graph_group_list: []
            };
        },
        clickSearch ({ ipName, isByNameSearch = false} = {}) {
            !isByNameSearch && Bus.$emit('clearIpName');
            const params = {};
            Object.keys(this.selectedOptions).forEach(key => {
                params[key] = (this.selectedOptions[key] || []).join(',');
            });
            request({
                url: '/v3/ad/activity/ip_pic/list',
                data: {
                    ...params,
                    query: ipName || ''
                }
            }).then((res) => {
                let {code, message} = res;
                if (code !== 200) {
                    toast(`数据获取失败：${code}-${message}`);
                    return;
                }
                window.getListData = res;
                this.$emit('refreshData');
            }).catch((error) => {
                toast(`详情页获取失败：${error}`);
            });
        },
        viewMore () {
            this.isViewMore = !this.isViewMore;
        }
    }
};
</script>

<style lang='scss' scoped>
@import "@/css/common.scss";
.search{
    position:relative;
    border: 1px solid #1E1E1E;
    border-radius: vws(40px);
    margin: 0 auto;
    width:vws(1184px);
    .twrap{
        background:white;
        position:absolute;
        top:vws(-25px);
        left:50%;
        transform:translateX(-50%);
        width:vws(180px);
        height:vws(50px);
        .title{
            color: #1E1E1E;
            font-size:vws(30px);
            font-weight:bold;
        }
        .dot{
            width:vws(5px);
            height:vws(5px);
            border-radius:50%;
            background: #1E1E1E;
        }
    }
    .cwrap{
        padding:vws(36px) 0 vws(34px);
        .more-btn{
            text-align: center;
            margin-top: vws(15px);
            font-size: vws(22px);
            font-weight: 500;
            color: #3699FF;
            .view-more-btn,.pack-more-btn{
                cursor:pointer;
                display: inline-block;
                padding-bottom: 1px;
                border-bottom: 1px solid #3699FF;
            }
        }
        .btn{
            cursor:pointer;
            font-size:0;
            margin:vws(37px) auto 0;
            width:vws(230px);
        }
    }
}
@media (max-width:1184px) {
    .search{
        width:100%;
    }
}
</style>


